var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Lifecycle, injectAll, injectable } from "tsyringe";
import { services } from '@quandis/qbo4.ui';
import { IConfigurationSourceToken, IConfigurationToken, iterateConfig } from "./IConfiguration.js";
export class JsonConfigurationSource {
    constructor(jsonConfig) {
        this.jsonConfig = jsonConfig;
    }
    getData() {
        return this.jsonConfig;
    }
    *getValues() {
        yield* iterateConfig(this.jsonConfig);
    }
}
export class EmptyConfigurationSource {
    getData() {
        return {};
    }
    *getValues() {
        yield* iterateConfig({});
    }
}
export class ConfigurationSection {
    constructor(sectionData) {
        this.data = sectionData;
    }
    getSection(path) {
        const keys = path.split(':');
        let currentSection = this.data;
        for (const key of keys) {
            if (!(key in currentSection)) {
                return new ConfigurationSection({}); // Or handle as needed
            }
            currentSection = currentSection[key];
        }
        return new ConfigurationSection(currentSection);
    }
    get(path) {
        const keys = path.split(':');
        let currentSection = this.data;
        for (const key of keys) {
            if (currentSection && (key in currentSection)) {
                currentSection = currentSection[key];
            }
            else {
                return {};
            }
        }
        return currentSection;
    }
    bind(type) {
        const instance = new type();
        for (const key in this.data) {
            if (this.data.hasOwnProperty(key)) {
                instance[key] = this.data[key];
            }
        }
        return instance;
    }
    *getValues() {
        yield* iterateConfig(this.data);
    }
}
let Configuration = class Configuration extends ConfigurationSection {
    //constructor(config: ConfigSection) {
    //    this.config = config;
    //}
    //constructor(@injectAll(ILoggerToken) private loggers: ILogger[], @injectAll(ILogReaderToken) private readers: ILogReader[]) {
    //    this.logTrace(`LoggingService.constructor loaded with ${loggers.length} loggers and ${readers.length} readers.`);
    //}
    constructor(sources) {
        super({});
        this.sources = sources;
        this.mergeConfigurations(sources);
    }
    mergeConfigurations(sources) {
        sources.forEach(source => {
            const section = source.getData();
            this.data = { ...this.data, ...section };
        });
    }
};
Configuration = __decorate([
    injectable(),
    __param(0, injectAll(IConfigurationSourceToken)),
    __metadata("design:paramtypes", [Array])
], Configuration);
export { Configuration };
// Register the Configuration class as a singleton
services.container.register(IConfigurationToken, { useClass: Configuration }, { lifecycle: Lifecycle.Singleton });
// Ensure we can have a default configuration source.
services.container.register(IConfigurationSourceToken, { useClass: EmptyConfigurationSource }, { lifecycle: Lifecycle.Singleton });
//# sourceMappingURL=Configuration.js.map